/** EN uses Swedish values until translated. */
export const pagesOverviewEn = {
    title: 'Overview',
    numberOfIssues: 'Number of issues',
    numberOfListedWarrants: 'Number of listed warrants',
    ongoingAndUpcoming: 'Ongoing and upcoming',
    ongoingAndUpcomingWarrants: 'Ongoing and upcoming issues and warrants',
    latest20RightsIssues: 'The most recent 20 rights issues',
    numberOfFutureAndOngoingRightsIssues: 'Number of ongoing and upcoming rights issues',
    averageTotalCommitment: 'Average secured level of recent 20 issues',
    averageOutcomeExclGuarantors: 'Average outcome of recent 20 rights issues',
    recentlyAnnouncedIssues: 'Latest announced issues',
    recentlyCompletedRightsIssues: 'Latest completed rights issues',
    statsShort: {
        numberOfIssues: 'issues',
        numberOfListedWarrants: 'listed warrants',
    },
}
